import React, { useState, useEffect } from 'react';
import styles from './index.module.sass';
import instructIos01 from 'assets/instruct_ios_01.jpg';
import instructIos02 from 'assets/instruct_ios_02.jpg';
import instructIos03 from 'assets/instruct_ios_03.jpg';
import instructAndroid01 from 'assets/instruct_android_01.jpg';
import instructAndroid02 from 'assets/instruct_android_02.jpg';
import instructAndroid03 from 'assets/instruct_android_03.jpg';
import instructAndroid04 from 'assets/instruct_android_04.jpg';
import iconShare from 'assets/icon_share.svg';
import iconShareAndroid from 'assets/icon_share_android.svg';
import iconMochi from 'assets/icon_mochi.svg';
import amplitude from 'service/amplitude';
import { PATH } from 'config';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

const ShortInstruction = () => {
  const history = useHistory();
  const location = useLocation();
  const search = qs.parse(location.search);
  const [backButtonShow, setBackButtonShow] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (search.edm) {
      setBackButtonShow(false);
    } else {
      amplitude.shortcut_pageview();
    }
  }, []); //eslint-disable-line

  const iosList = [
    {
      text: (
        <>
          ➀ Safari 瀏覽器，選擇底部 <img src={iconShare} alt="share" height="17" width="auto" /> 分享按鈕。
        </>
      ),
      image: instructIos01,
    },
    {
      text: '➁ 選擇「加入主畫面」。',
      image: instructIos02,
    },
    {
      text: '➂ 選擇畫面右上角「新增」。',
      image: instructIos03,
    },
  ];

  const androidList = [
    {
      text: (
        <>
          ➀ Chrome 瀏覽器，選擇右上方 <img src={iconShareAndroid} alt="share" height="13" width="auto" /> 選項按鈕。
        </>
      ),
      image: instructAndroid01,
    },
    {
      text: '➁ 選擇「加到主畫面」。',
      image: instructAndroid02,
    },
    {
      text: '➂ 選擇「新增」。',
      image: instructAndroid03,
    },
    {
      text: '➃ 若為 Pixel 手機請繼續選擇新增到主畫面。',
      image: instructAndroid04,
    },
  ];

  const onBack = () => {
    amplitude.shortcut_back_onClick();
    history.push(PATH.MAIN);
  };

  return (
    <div className={styles.shortcut}>
      {backButtonShow && (
        <div className={styles.back} onClick={onBack}>
          返回
        </div>
      )}
      <div className={styles.heading}>
        <img src={iconMochi} alt="mochi" />
        <h1>將網頁儲存主畫面 App 捷徑</h1>
        <h2>即時開啟網頁跟 App 一樣好用。</h2>
        <ul className={styles.buttons}>
          <li>
            <a href="#ios-instruction" onClick={() => amplitude.shortcut_iphone_onClick()}>
              iPhone
            </a>
          </li>
          <li>
            <a href="#android-instruction" onClick={() => amplitude.shortcut_android_onClick()}>
              Android
            </a>
          </li>
        </ul>
      </div>
      <ul className={styles.ios} id="ios-instruction">
        <h3>使用 iPhone 加入</h3>
        {iosList.map((item, key) => {
          return (
            <li key={key}>
              <p>{item.text}</p>
              <img src={item.image} alt="instruction" />
            </li>
          );
        })}
      </ul>
      <ul className={styles.android} id="android-instruction">
        <h3>使用 Android 加入</h3>
        {androidList.map((item, key) => {
          return (
            <li key={key}>
              <p>{item.text}</p>
              <img src={item.image} alt="instruction" />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ShortInstruction;
